<template>
    <div class="roothome">

        <div class="wrapper">
            <!-- Sidebar Holder -->
            <nav id="sidebar">
                <div id="dismiss">
                    <!--<img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu1">-->
                </div>

                <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center;">

                    <div style="width: 100%; text-align: center;">
                        <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="width: 70%; margin-top: 5vh; margin-bottom: 2.5vh;">
                    </div>

                    <!--<div style="margin-bottom: 2.5vh">-->
                    <!--<span class="tx_idioma" v-if="user.idioma==0" style="font-family: 'Humanst521BT';">Português</span>-->
                    <!--<span class="tx_idioma" v-if="user.idioma!=0" @click="changeIdioma(0)">Português</span>-->
                    <!--<span class="tx_idioma">&#149;</span>-->
                    <!--<span class="tx_idioma" v-if="user.idioma==1" style="font-family: 'Humanst521BT';">English</span>-->
                    <!--<span class="tx_idioma" v-if="user.idioma!=1" @click="changeIdioma(1)">English</span>-->
                    <!--<span class="tx_idioma">&#149;</span>-->
                    <!--<span class="tx_idioma" v-if="user.idioma==2" style="font-family: 'Humanst521BT';">Español</span>-->
                    <!--<span class="tx_idioma" v-if="user.idioma!=2" @click="changeIdioma(2)">Español</span>-->
                    <!--</div>-->

                    <div v-if="user.sucess" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <span style="font-size: 2.5vh;">{{ getInterText(inter_ind.ola) }} {{ getFirstAndLastWords(user.nome) }}</span>

                        <div class="div_botao_t" @click="logout()" onMouseOver="this.style.cursor='pointer'">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.sair) }} </span>
                        </div>
                    </div>
                    <div v-else style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                        <router-link to="registerUser" style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center;">
                            <div class="div_botao_t_w">
                                <span class="tx_continuar"> {{ getInterText(inter_ind.cadastre) }} </span>
                            </div>
                        </router-link>

                        <div class="div_botao_t" @click="setShowLogin(true)">
                            <span class="tx_continuar"> {{ getInterText(inter_ind.entrar) }} </span>
                        </div>
                    </div>


                    <div class="custom-select-filtro">
                        <select class=".selectCity" id="sel_cats" @change="changeCity($event)" v-model="cityIndex" >
                            <option value="0" v-if="city_full.length > 0"> {{ city_full[0].nome }} </option>
                            <option v-for="(item, index) in city_full" :value="index" v-if="index > 0"> {{ item.nome }} ({{ item.quant }}) </option>
                        </select>
                        <img src="/static/imgs/ic_down.png" style="width: 5%; margin-right: 3%; object-fit: contain;">
                    </div>


                </div>
                <ul class="list-unstyled components noScrollMenu" style="margin-top: 0; overflow-y: scroll; font-size: 1.2vw;">
                    <li class="active">
                        <a href="#pageSubmenu" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.categorias) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu" >
                            <li v-for="(item, index) in cats_full" v-if="index > 0">
                                <div class="lineMenu" @click="goToHomeDesk(item.id)">
                                    <img v-if="item.imgPath2!=null" :src="baseUrlImg + 'CATEGORIA/' + item.imgPath2" class="im_cat_min">
                                    <span style="font-size: 2.2vh;">{{ getInterCatName(item) }}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="/Visao" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.quem_somos) }}</a>
                    </li>

                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu3" data-toggle="collapse" aria-expanded="false" aria-controls="pageSubmenu3">{{ getInterText(inter_ind.nossas_redes) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu3" >
                            <li>
                                <a href="https://www.facebook.com/adviceparaiba" target="_blank">
                                    <img src="/static/imgs/ic_facebookmenu.png" class="im_cat_min_2">
                                    <span>Facebook</span>
                                </a>
                                <a href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg" target="_blank">
                                    <img src="/static/imgs/ic_youtubemenu.png" class="im_cat_min_2">
                                    <span>YouTube</span>
                                </a>
                                <a href="https://www.instagram.com/adviceparaiba/" target="_blank">
                                    <img src="/static/imgs/ic_instagrammenu.png" class="im_cat_min_2">
                                    <span>Instagram</span>
                                </a>
                                <a href="https://twitter.com/AdviceParaiba" target="_blank">
                                    <img src="/static/imgs/ic_twittermenu.png" class="im_cat_min_2">
                                    <span>Twitter</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li @click='goToPagina("tabua")'>
                        <a style="font-family: 'Humanst521BT'; pointer-events: none;"> {{ getInterText(inter_ind.tabua_mares) }} </a>
                    </li>
                    <!--<li @click="changeShow10Mais()" style="cursor: pointer;">-->
                        <!--<a style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.os) }} 10+</a>-->
                    <!--</li>-->
                    <li>
                        <a href="/Contato" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.contato) }}</a>
                    </li>
                    <li>
                        <a href="/ExpedicaoAdvice" style="font-family: 'Humanst521BT';">{{ getInterText(inter_ind.expedicao) }}</a>
                    </li>
                    <li class="active">
                        <a style="font-family: 'Humanst521BT';" href="#pageSubmenu2" data-toggle="collapse"x aria-expanded="false" aria-controls="pageSubmenu2">{{ getInterText(inter_ind.telefones_uteis) }}</a>
                        <ul class="collapse list-unstyled" id="pageSubmenu2">
                            <li v-for="item in telefoneUteis">
                                <a :href="'tel:' + trimAll(item.tel)" style="margin-left: 5px">{{ getInterText(item.nome) }}: {{ item.tel }}</a>
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- PARCEIROS -->
                <!--<div class="div_pat_m">-->
                    <!--<hr class="hr_pat"/>-->
                    <!--<div style="display: flex;">-->
                        <!--<a v-for="item in barra_pat" :href="item.url" target="_blank"><img :src="item.imgPathW" class="im_pat_m"/></a>-->
                    <!--</div>-->
                <!--</div>-->
            </nav>

            <div v-if="!show10Mais" class="section_desk" id="sidebarCollapse" @click="changeSideBar()">
                <a class="navicon-button x" id="icmenu" >
                    <div class="navicon">
                    </div>
                </a>
            </div>

                <!-- ################    Top Menu Bar    ################# -->
                <div align="center" class="head0">
                    <div class="head1">
                        <!--<img src="/static/imgs/ic_menu.png" alt="menu" class="im_menu" id="sidebarCollapse" onMouseOver="this.style.cursor='pointer'">-->
                    </div>
                    <div class="head2">
                        <!-- ################    Title    ################# -->
                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, anuncios: anuncios}, name: 'Home'}" style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: flex-start;">
                            <img src="/static/imgs/advicep_horizontal.png" alt="logo advice" class="im40_2">
                        </router-link>
                    </div>
                    <div  class="head3">
                        <!--<div style="display: flex; height: 35%; width: 100%; align-items: center; justify-content: center;">-->
                            <!--<div class="bar_idiomas">-->
                                <!--<img v-if="user.idioma==0" src="/static/imgs/ic_b_pt.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<img v-if="user.idioma==1" src="/static/imgs/ic_b_en.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<img v-if="user.idioma==2" src="/static/imgs/ic_b_es.jpg" alt="barra idiomas" style="height: 70%;">-->
                                <!--<span style="font-size: 2vh; color: black; margin-right: 7%;"> {{ getIdioma(user.idioma) }} </span>-->
                                <!--<select @change="changeIdiomaSelector($event)" v-model="user.idioma" style="border:0px; outline:0px; border: none; scroll-behavior: smooth; background-color: white; -webkit-appearance:none; font-size: 2vh; position: absolute; opacity: 0; width: 100%;">-->
                                    <!--<option value="0"> Português&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                    <!--<option value="1"> English&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                    <!--<option value="2"> Español&nbsp;&nbsp;&nbsp;&nbsp;</option>-->
                                <!--</select>-->
                            <!--</div>-->
                        <!--</div>-->
                        <span class="tx_title_guia">{{getInterText(inter_ind.seu_guia_turistico)}}</span>
                        <div class="im_id_container">
                            <img class="im_id" v-if="user.idioma==0" src="/static/imgs/ic_pt2.png"/>
                            <img class="im_id" v-if="user.idioma!=0" src="/static/imgs/ic_pt1.png" @click="changeIdioma(0)"/>
                            <img class="im_id" v-if="user.idioma==1" src="/static/imgs/ic_en2.png"/>
                            <img class="im_id" v-if="user.idioma!=1" src="/static/imgs/ic_en1.png" @click="changeIdioma(1)"/>
                            <img class="im_id" v-if="user.idioma==2" src="/static/imgs/ic_es2.png"/>
                            <img class="im_id" v-if="user.idioma!=2" src="/static/imgs/ic_es1.png" @click="changeIdioma(2)"/>
                        </div>

                        <!--<div style="display: flex; height: 40%; margin-left: 10%; margin-right: 10%;">-->
                            <!--<a target="_blank" href="https://www.youtube.com/channel/UCbWLHHK-IIHT6BZRWU0n5eg"><img src="/static/imgs/ic_youtube2.png" alt="youtube" class="im_social"></a>-->
                            <!--<a target="_blank" href="https://www.facebook.com/adviceparaiba/"><img src="/static/imgs/ic_face2.png" alt="facebook" class="im_social"></a>-->
                            <!--<a target="_blank" href="https://www.instagram.com/adviceparaiba/"><img src="/static/imgs/ic_instagram2.png" alt="instagram" class="im_social"></a>-->
                            <!--<a target="_blank" href="https://twitter.com/AdviceParaiba"><img src="/static/imgs/ic_twitter2.png" alt="twitter" class="im_social"></a>-->
                        <!--</div>-->
                    </div>
                    <div  class="head4">
                        <div v-if="!user.sucess" style="display: flex; flex-direction: column; align-items: center">
                            <div style="display: flex; height: 100%; min-height: 100%; align-items: flex-end;">
                                <a href="/registerUser" >
                                    <span class="tx_login2" >{{ getInterText(inter_ind.cadastre) }} </span>
                                </a>
                            </div>

                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <img @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'" src="/static/imgs/ic_profile2.png" alt="profile" class="im_profile" style="height: 25%; margin-right: 0; margin-left: 0; margin-bottom: -15%;">

                                <span class="tx_login" style="margin-bottom: 1%; color: var(--gray-menu)" @click="setShowLogin(true)" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.entrar) }}</span>
                            </div>

                        </div>
                        <div v-else @click="showPopEscritorio()" style="cursor: pointer;">
                            <div v-if='user.foto === ""' class="im_profile" style="text-align: center; padding-top: 1.2vh; background-color: var(--bg-blue)">
                                <span class="tx_initials" >{{ getInitials(user) }}</span>
                            </div>
                            <img id="botao_profile2" v-else-if='hasHttp(user.foto)'  :src='user.foto' alt="profile" class="im_profile">
                            <img id="botao_profile3" v-else :src='baseUrlImg + "PROFILE/" + user.foto'     alt="profile" class="im_profile">
                            <br>
                            <span class="tx_login5" >{{ getFirstAndLastWords(user.nome) }}</span>
                            <div style="width: 100%; display: flex; justify-content: center;">
                                <div class="triangle"></div>
                            </div>
                        </div>
                        <div v-if="showPopupEscritorio" class="di_popescritorio" id="popup_escritorio">
                            <div class="arrow_top"></div>
                            <!--<span class="tx_login" >{{ user.nome }}</span>-->
                            <div style="display: flex; flex-direction: column; height: 15vh; justify-content: space-evenly;">
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'">{{ getInterText(inter_ind.minha_conta) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="goToPagina('EditUser')">{{ getInterText(inter_ind.configuracoes) }}</span>
                                <span class="tx_login" onMouseOver="this.style.cursor='pointer'" @click="logout()">{{ getInterText(inter_ind.sair) }}</span>
                            </div>
                        </div>
                    </div>
                </div>

            <div style="display: flex; justify-content: center;">

                <!-- ################    panorama e busca    ################# -->
                <div class="title4" style="">




                    <span style="background-color: white; width: 100%; height: 6vh; font-size: 3.5vh; display: flex; align-items: center; justify-content: center; margin-top: 1vh; border-radius:10px;">{{ getInterText(inter_ind.minha_conta) }}</span>
                    <!--<span style="background-color: white; width: 100%; height: 5.5vh; font-size: 2.6vh; display: flex; align-items: center; justify-content: center; margin-top: 2vh; border-radius:10px;">{{ getInterText(inter_ind.minha_conta) }}</span>-->




                    <!-- ################    Estabelecimentos TAB Header ################# -->
                    <div style="display: flex; flex-direction: row; margin-top: 8vh; justify-content: space-between; flex-wrap: wrap;">
                        <div v-if="currentTab==3" class="di_tab_s" @click="changeTab(3)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_mensagens_blue.png"/>
                            <span class="tx_notselect" > {{ getInterText(inter_ind.mensagens) }} ({{ commentaries.length }})</span>
                        </div>
                        <div v-else class="di_tab" @click="changeTab(3)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_mensagens_blue.png"/>
                            <span class="tx_notselect" > {{ getInterText(inter_ind.mensagens) }} ({{ commentaries.length }})</span>
                        </div>

                        <!--<div class="di_tab" style="margin: 0; margin-bottom: 2vh !important; margin-top: 2vh !important; background-color: var(&#45;&#45;menu-icon-gray); height: auto; max-width: 1px; padding: 0; border-width: 0; font-size: 0;">-->
                        <!--</div>-->

                        <div v-if="currentTab==2" class="di_tab_s" @click="changeTab(2)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                            <span class="tx_notselect" > {{ getInterText(inter_ind.favoritos) }} ({{ getEstabsUser(2).length }}) </span>
                        </div>
                        <div v-else class="di_tab" @click="changeTab(2)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                            <span class="tx_notselect" > {{ getInterText(inter_ind.favoritos) }} ({{ getEstabsUser(2).length }})</span>
                        </div>

                        <!--<div class="di_tab" style="margin: 0; margin-bottom: 2vh !important; margin-top: 2vh !important; background-color: var(&#45;&#45;menu-icon-gray); height: auto; max-width: 1px; padding: 0; border-width: 0; font-size: 0;">-->
                        <!--</div>-->

                        <div v-if="currentTab==1" class="di_tab_s" @click="changeTab(1)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                            <span class="tx_notselect" > {{ getInterText(inter_ind.minhas_paginas) }} ({{ getEstabsUser(1).length }})</span>
                        </div>
                        <div v-else class="di_tab" @click="changeTab(1)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                            <span class="tx_notselect" > {{ getInterText(inter_ind.minhas_paginas) }} ({{ getEstabsUser(1).length }})</span>
                        </div>


                        <div v-if="currentTab==4 && user.tipo == 1" class="di_tab_s" @click="changeTab(4)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                            <span class="tx_notselect" > Liberação ADM ({{ getEstabsUser(4).length }})</span>
                        </div>
                        <div v-else-if="user.tipo == 1" class="di_tab" @click="changeTab(4)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_favoritos_blue.png"/>
                            <span class="tx_notselect" > Liberação ADM ({{ getEstabsUser(4).length }})</span>
                        </div>


                        <div v-if="currentTab==5 && user.tipo == 1" class="di_tab_s" @click="changeTab(5)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                            <span class="tx_notselect" > Dica Advice ({{ anuncios.length }})</span>
                        </div>
                        <div v-else-if="user.tipo == 1" class="di_tab" @click="changeTab(5)" onMouseOver="this.style.cursor='pointer'">
                            <img class="im_subtitle" src="/static/imgs/ic_minhapagina_blue.png"/>
                            <span class="tx_notselect" > Dica Advice ({{ anuncios.length }})</span>
                        </div>

                        <div style="flex-basis: 30%;"></div>
                    </div>



                    <!-- Texto de apresentação-->
                    <div style="display: flex; flex-direction: row; align-items : center; justify-content: center; width: 96%; max-width: 96%; flex-wrap: wrap; margin-left: 1%; margin-right: 1%; margin-top: var(--minhaPagina-margin-top);">
                        <div class="div_apresenta" v-if="user.showMsg3 && currentTab == 3">
                            <img class="im_apresenta" src="/static/imgs/ic_msg_purple.png">
                            <span class="tx_apresenta">Mais facilidade para você poder acompanhar e gerenciar os comentários.</span>
                            <span class="tx_apresenta">Todas as interações de usuários direcionadas ao seu perfil, ou em suas páginas, estarão disponíveis para resposta por aqui.</span>
                            <span class="tx_apresenta_ok" @click="closeUserMsg(3)">ENTENDI</span>
                        </div>

                        <div class="div_apresenta" v-if="user.showMsg2 && currentTab == 2">
                            <img class="im_apresenta" src="/static/imgs/ic_tick_purple.png">
                            <span class="tx_apresenta">Todas as páginas que foram marcadas como favoritas serão exibidas aqui.</span>
                            <span class="tx_apresenta">Uma ótima forma de salvar e organizar em um só local os melhores destinos.</span>
                            <span class="tx_apresenta_ok" @click="closeUserMsg(2)">ENTENDI</span>
                        </div>

                        <div class="div_apresenta" v-if="user.showMsg1 && currentTab == 1">
                            <img class="im_apresenta" style="width: 15%;" src="/static/imgs/ic_new_pg_purple.png">
                            <span class="tx_apresenta">Para você que quer divulgar o seu estabelecimento, ou algum tipo de serviço que se enquadre em nossa proposta, crie a sua página, faça bons negócios, e contribuia com o turismo do Estado.</span>
                            <span class="tx_apresenta"> Clique no link abaixo para ficar por dentro dos requisitos básicos de criação de página.</span>
                            <div style="display: flex; justify-content: space-between;">
                                <span class="tx_apresenta_ok" @click="showCriacaoPagina(true)">REQUISITOS PARA A CRIAÇÃO DE PÁGINA</span>
                                <span class="tx_apresenta_ok" @click="closeUserMsg(1)">ENTENDI</span>
                            </div>
                        </div>

                        <div class="div_apresenta" v-if="showCriacaoPg">
                            <span class="tx_apresenta_title" style="cursor: unset; align-self: unset;">Requisitos Advice para criação de página:</span>

                            <div style="display: flex; justify-content: space-between; align-items: center; align-content: center;">
                                <div style="display: flex; flex-direction: column; width: 75%;">
                                    <span class="tx_apresenta">Preencha todos os campos. <img src="static/imgs/ic_joia_purple.png" style="height: 3vh; object-fit: contain"> </span>
                                    <span class="tx_apresenta">No texto de apresentação procure ser claro, apresentando todas as informações necessárias. Foque nos pontos fortes do seu negócio. <img src="static/imgs/ic_joia_purple.png" style="height: 3vh; object-fit: contain"> </span>
                                    <span class="tx_apresenta">Fique atento às categorias que a sua página se enquadra. Podendo escolher até 3. <img src="static/imgs/ic_joia_purple.png" style="height: 3vh; object-fit: contain"> </span>
                                    <span class="tx_apresenta">Poste fotos que valorizem a sua página. Fotos horizontais, com uma boa iluminação, nitidez e foco. Não se esqueça de variar os ângulos para mostrar todas as perspectivas necessárias. <img src="static/imgs/ic_joia_purple.png" style="height: 3vh; object-fit: contain"> </span>
                                </div>
                                <img class="im_apresenta" src="/static/imgs/ic_new_pg_purple.png">
                            </div>
                            <span class="tx_apresenta_ok" @click="showCriacaoPagina(false)">ENTENDI</span>
                        </div>
                    </div>


                    <!--<div v-if="currentTab==4 && user.tipo == 1" style="margin-left: 3%; display: inline-block; background-color: white;">-->
                        <!--<span @click="changeTab(4)" style="font-size: 2vh; cursor: pointer;">Liberação ADM ({{ getEstabsUser(4).length }})</span>-->
                    <!--</div>-->
                    <!--<div v-if="currentTab!=4 && user.tipo == 1" style="margin-left: 3%;">-->
                        <!--<span @click="changeTab(4)" style="font-size: 2vh;">Liberação ADM ({{ getEstabsUser(4).length }})</span>-->
                    <!--</div>-->

                    <!--border-top: none; border-right: none; border-left: none;-->
                    <div v-if="currentTab == 1" style="font-size: 4vh; margin-top: 5vh; display: flex; justify-content: space-between; border-style: solid; border-color: var(--bg-blue-circle); border-width: 1px; border-top: none; border-right: none; border-left: none;">
                        <div style="width: 28vw;">
                            <span v-if="statusEstab==0" class="tx_status_estab_s"             > Ativas ({{ getEstabsUser(1, 0).length }}) </span>
                            <span v-else class="tx_status_estab" @click="changeStatusEstab(0)"> Ativas ({{ getEstabsUser(1, 0).length }}) </span>
                        </div>
                        <div style="width: 28vw;">
                            <span v-if="statusEstab==1" class="tx_status_estab_s"             > Em Análise ({{ getEstabsUser(1, 1).length }}) </span>
                            <span v-else class="tx_status_estab" @click="changeStatusEstab(1)"> Em Análise ({{ getEstabsUser(1, 1).length }}) </span>
                        </div>
                        <div style="width: 28vw;">
                            <span v-if="statusEstab==2" class="tx_status_estab_s"             > Inativas ({{ getEstabsUser(1, 2).length }}) </span>
                            <span v-else class="tx_status_estab" @click="changeStatusEstab(2)"> Inativas ({{ getEstabsUser(1, 2).length }}) </span>
                        </div>
                    </div>

                    <!-- ################    Estabelecimentos Mesmo  ################# -->
                    <div style="display: flex; flex-direction: row; margin-top: 10vh;">
                        <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; width: 96%; max-width: 96%; flex-wrap: wrap; margin-left: 1vw; margin-right: 1vw;">

                            <!-- MINHA PAGINA E FAVORITOS-->
                            <div v-for="item in getEstabsUser(currentTab, statusEstab)" v-if="(currentTab == 1 || currentTab == 2 || currentTab == 4) && item.tbFotos[0]!=null" class="di_mmp_estab0">

                                <div class="di_mmp_estab1" style="display: flex; flex-direction: column; width: 100%; height: auto; align-items: flex-start; " v-if="item.tbFotos[0]!=null" >
                                    <router-link :to="{ query: { id: item.id }, params: { stabs: estabs_full, categs: cats_full, anuncios: anuncios}, name: 'Estabelecimento'}" style="margin: 0; padding: 0;">
                                        <div class="di_mmp_estab2" >
                                            <img onerror="tryReloadImages(this)" style="width: 100%; height: var(--min-pag-stab-height); object-fit: cover;" v-if="item.tbFotos!=null" :src="baseUrlImg + '/MARCADOR/' + item.tbFotos[0].file" alt="Foto Principal" class="imgDestaques"/><br>
                                        </div>


                                    </router-link>
                                    <div style="display: flex; flex-direction: column; width: 100%; align-items: flex-start;">
                                        <span class="tx_title_estab" style="font-family: 'Humanst521BT'; white-space: pre; max-width: 100%; overflow-x: hidden; text-overflow: ellipsis;" v-html="decodeChars(item.nome)"> </span>
                                        <span class="tx_cats_estab" style="white-space: pre; max-width: 100%; overflow-x: hidden; text-overflow: ellipsis;">{{ getCatsStr(item) }}</span>
                                        <span class="tx_cats_estab" v-if="(currentTab == 4)" style="white-space: pre; max-width: 100%; overflow-x: hidden; text-overflow: ellipsis;">User: {{ item.idUsuario }}</span>
                                        <span class="tx_cats_estab" v-if="(currentTab == 4)" style="white-space: pre; max-width: 100%; overflow-x: hidden; text-overflow: ellipsis;">Cad: {{ item.dtCadastro }}</span>
                                        <span class="tx_cats_estab" v-if="(currentTab == 4)" style="white-space: pre; max-width: 100%; overflow-x: hidden; text-overflow: ellipsis;">Alt: {{ item.dtAlteracao }}</span>
                                        <div style="display: flex; flex-direction: row; width: 100%; justify-content: space-between">
                                            <div class="di_star_wrap" style="max-width: 13.5vh; height: 2.5vh;" >
                                                <div alt="estrelas" class="im_star" :style="'width: ' + ((item.avaliacao * 100)/5.0) + '%;'" align="right"/>
                                            </div>
                                            <div v-if="currentTab == 2" style="display: flex; flex-direction: column; justify-content: center; margin-bottom: 1vh;">
                                                <img v-if="isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 0" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />
                                                <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 0" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div style="display: flex; width: 100%; justify-content: center; margin-top: 1vh;">
                                    <div v-if="currentTab == 1 || currentTab == 4" style="display: flex; flex-direction: row; justify-content: space-around; align-items: center; width: 100%;">

                                        <router-link :to="{ params: { stab: item, stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterEstab'}">
                                            <div style="display: flex; flex-direction: row; margin-bottom: 0.8vh; cursor: pointer;">
                                                <img style="width: 3vh; height: 3vh; margin-right: 6px; object-fit: contain;" src='/static/imgs/ic_edit_sq.png' alt="Foto Principal" class="imgDestaques"/><br>
                                                <span style="align-self: center;">{{ getInterText(inter_ind.editar) }}</span>
                                            </div>
                                        </router-link>

                                        <div style="display: flex; flex-direction: row; align-items: center;" @click="sendAprovado(item)">
                                            <img v-if="!item.aprovado"               style="width: 2.2vh; height:2.2vh; margin-right: 6px;" src='/static/imgs/ic_ball_red.png' alt="Foto Principal" class="imgDestaques"/>
                                            <img v-if="item.aprovado && item.ativo"  style="width: 2.2vh; height:2.2vh; margin-right: 6px;" src='/static/imgs/ic_ball_green.png' alt="Foto Principal" class="imgDestaques"/>
                                            <img v-if="item.aprovado && !item.ativo" style="width: 2.2vh; height:2.2vh; margin-right: 6px;" src='/static/imgs/ic_ball_gray.png' alt="Foto Principal" class="imgDestaques"/>
                                            <br><br><br>
                                            <span v-if="!item.aprovado"               style="align-self: center; font-size: 2vh;">{{ getInterText(inter_ind.em_analise) }}</span>
                                            <span v-if="item.aprovado && item.ativo"  style="align-self: center; font-size: 2vh;">{{ getInterText(inter_ind.ativa) }}</span>
                                            <span v-if="item.aprovado && !item.ativo" style="align-self: center; font-size: 2vh;">{{ getInterText(inter_ind.desativada) }}</span>
                                        </div>

                                    </div>
<!--                                    <div v-if="currentTab == 2" style="display: flex; flex-direction: column; justify-content: center;">-->
<!--                                        <img v-if="isFavorite(item.id)" src="/static/imgs/ic_favoritos.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 0" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />-->
<!--                                        <img v-else src="/static/imgs/ic_favoritos_not.png" alt="favoritos" class="im_fav_mpagina" style="margin-left: 0" onMouseOver="this.style.cursor='pointer'" @click="sendFavoriteAvaliacao(item.id, -1)" />-->
<!--                                    </div>-->


                                </div>
                            </div>


                            <div v-if="(currentTab == 2 || currentTab == 1) && getEstabsUser(currentTab).length == 0" style="height: 30vh; display: flex; align-items: center;">
                                <span class="tx_apresenta" v-if="currentTab == 2">Nenhum Favorito adicionado</span>
                                <span class="tx_apresenta" v-if="currentTab == 1">Nenhum estabelecimento cadastrado</span>
                            </div>

                            <div v-if="(currentTab == 3) && commentaries.length == 0" style="height: 30vh; display: flex; align-items: center;">
                                <span class="tx_apresenta" v-if="currentTab == 3">Nenhuma mensagem ou comentário</span>
                            </div>

                            <div v-if="(currentTab == 5) && anuncios.length == 0" style="height: 30vh; display: flex; align-items: center;">
                                <span class="tx_apresenta" v-if="currentTab == 3">Nenhum Anúncio encontrado</span>
                            </div>

                            <!-- MENSAGENS -->
                            <div v-for="(item, index) in commentaries.slice().reverse()" v-if="(currentTab == 3)" class="di_mmp_estab0_msg" style="width: 95vw; min-height: 15vw; padding: 3vw; padding-top: 4vw; padding-left: 4vw; padding-right: 1vw;" :key="item.id">
                                <div style="display: inline-block; text-align: start; width: 12%;">
                                    <img v-if='hasHttp(item.userPhoto)'  :src='unscapePath(item.userPhoto)' alt="profile" class="im1" :title="item.userName">
                                    <img v-else :src='baseUrlImg + "PROFILE/" + item.userPhoto'          alt="profile" class="im1" :title="item.userName">
                                </div>
                                <div style="display: flex; flex-direction: column; width: 76%; margin-left: 2%;" >

                                    <div style="text-align: left;">
                                        <router-link :to="{ query: { id: item.idEstabelecimento }, params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'Estabelecimento'}">
                                            <span class="tx_title_estab" style="font-weight: bold; display: inline-block;" v-html="decodeChars(item.estabName)"></span>
                                        </router-link>
                                    </div>

                                    <div @click="setShowRespComments(index)" style="cursor: pointer; text-align: left;">
                                        <div style="display: flex; flex-direction: row;">
                                            <span class="tx_cats_estab" style="font-weight: bold"> {{ getFirstAndLastWords(item.userName) }}</span>
                                            <span class="tx_cats_estab" style="margin-right: 1vw; margin-left: 1vw; color: #acadaf">{{ calcBehindTime(item.data) }}</span>
                                            <!--<img src="/static/imgs/bt_erase.png" alt="erase" class="im_del_comment" @click="rmCommentary(item.id)">-->
                                        </div>

                                        <div v-if="renderCommentaries" class="tx_cats_estab" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                            {{ item.tx_trans }}
                                        </div>

                                        <div v-if="showRespComments != index" style="display: flex; flex-direction: column; position: relative; vertical-align: top; text-align: justify; margin-top: 1vw; margin-bottom: 1vw; color: #acadaf">
                                            <span class="tx_notselect_msg" v-if="item.resps != undefined && item.resps.length == 1">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.resposta) }}</span>
                                            <span class="tx_notselect_msg" v-if="item.resps != undefined && item.resps.length > 1">{{ getInterText(inter_ind.ver) }} {{ item.resps.length }} {{ getInterText(inter_ind.respostas) }}</span>
                                        </div>

                                        <div v-else style="display: flex; flex-direction: column; position: relative; vertical-align: top; text-align: justify; margin-top: 1vw; margin-bottom: 0; color: #acadaf">
                                            <span class="tx_notselect_msg" v-if="item.resps != undefined && item.resps.length == 1" > {{ getInterText(inter_ind.resposta) }}: </span>
                                            <span class="tx_notselect_msg" v-if="item.resps != undefined && item.resps.length > 1"> {{ getInterText(inter_ind.respostas) }}: </span>
                                        </div>
                                    </div>

                                    <div v-if="showRespComments==index" v-for="(itemResp, indexResp) in item.resps" style="display: flex; flex-direction: column; width: 100%; position: relative; margin-bottom: 2vh;" :key="itemResp.id">
                                        <div style="display: flex; align-items: flex-start; position: relative; height: 100%;">
                                            <div style="display: inline-block; text-align: start; width: 12%; height: 100%;">
                                                <img v-if='hasHttp(itemResp.userPhoto)'  :src='unscapePath(itemResp.userPhoto)' alt="profile" class="im1" :title="itemResp.userName">
                                                <img v-else :src='baseUrlImg + "PROFILE/" + itemResp.userPhoto'              alt="profile" class="im1" :title="itemResp.userName">
                                            </div>
                                            <div style="display: flex; flex-direction: column; width: 72%; align-self: flex-start; margin-left: 6%;">
                                                <div style="display: inline-block; position: relative; vertical-align: top; text-align: justify;">
                                                    <span class="tx_cats_estab" style="color: darkblue">{{ getFirstAndLastWords(itemResp.userName) }}</span>
                                                    <span class="tx_cats_estab" style="color: #acadaf">{{ calcBehindTime(itemResp.data) }}</span>
                                                    <!--<img src="/static/imgs/bt_erase.png" alt="erase" class="im_del_comment" @click="rmCommentary(itemResp.id)">-->
                                                </div>
                                                <div v-if="renderCommentaries" class="tx_cats_estab" style="display: inline-block; position:relative; vertical-align: top; text-align: justify;">
                                                    {{ itemResp.tx_trans }}
                                                </div>

                                                <div style="color: #acadaf; text-align: left;">
                                                    <span @click="setShowResponder(indexResp)" style="cursor: pointer; font-size: 2vh;">{{ getInterText(inter_ind.responder) }}</span>
                                                    <span v-if="itemResp.idUsuario == user.id" @click="rmCommentary(itemResp.id)" onMouseOver="this.style.cursor='pointer'" style="margin-left: 5vw; font-size: 2vh;">{{ getInterText(inter_ind.excluir) }} </span>
                                                </div>

                                                <textarea v-if="showResponder==indexResp" type="text" class="search" style="width: 100%;" :placeholder="getInterText(inter_ind.responda_comentario)" v-model="commentRespTx"></textarea>
                                                <div v-if="showResponder==indexResp" style="display: flex; justify-content: flex-end;">
                                                    <div style="background-color: var(--bg-purple); border-radius: 10px;" onMouseOver="this.style.cursor='pointer'" @click="addCommentary(item.id, index, item.idEstabelecimento)">
                                                        <span style="color: white; padding-right: 2vh; padding-left: 2vh; font-size: 2vh;">{{ getInterText(inter_ind.enviar_resposta) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="div_joia2" style="width: 14%; align-self: flex-start; margin-top: 2vw;">
                                                <img v-if="isLiked(itemResp.id)" onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 0)" src="/static/imgs/ic_like_on.png" alt="joia up" class="im_joia1">
                                                <img v-else onMouseOver="this.style.cursor='pointer'" @click="sendCurtida(itemResp, 1)"  src="/static/imgs/ic_like_off.png"  alt="joia up" class="im_joia1">
                                                <span style="margin-left: 5%;">{{ itemResp.qLikes }}</span>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div v-if="showRespComments == index && item.resps.length > 0" @click="setShowRespComments(index)" style="display: flex; flex-direction: column; justify-content: flex-start; align-items: center; width: 10%; margin-top: -1vw;">
                                    <img src="/static/imgs/bt_fechar.png" alt="erase" class="im_del_comment">
                                    <span style="color: #acadaf; font-size: 1.5vh;">{{ getInterText(inter_ind.fechar) }}</span>
                                </div>

                                <div v-else-if="item.idUsuario == user.id" style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 13%;">
                                    <img src="/static/imgs/bt_erase.png" alt="erase" class="im_del_comment_big" @click="rmCommentary(item.id)">
                                    <span style="color: #acadaf; font-size: 1.3vh;">{{ getInterText(inter_ind.excluir) }}</span>
                                </div>

                            </div>


                            <!-- Exibe Anuncios Existentes -->
                            <div v-for="item in getAnunciosDecoded(anuncios)" v-if="(currentTab == 5)" class="di_mmp_estab0">

                                <div class="di_mmp_estab1" style="display: flex; flex-direction: column; width: 100%; height: auto; align-items: flex-start;" >
                                    <router-link :to="{ params: { product: truncateAnuncio(item), stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterAnuncio'}" style="margin: 0; padding: 0;">
                                        <div class="di_mmp_estab2" v-if="item.photos !== undefined && item.photos.length > 0">
                                            <img onerror="tryReloadImages(this)" style="width: 100%; height: var(--min-pag-stab-height); object-fit: cover;" :src="baseUrlImg + '/MARCADOR/' + item.photos[0].file" alt="Foto Principal" class="imgDestaques"/><br>
                                        </div>
                                    </router-link>
                                    <div style="display: flex; flex-direction: column; width: 100%; align-items: flex-start;">
                                        <span class="tx_title_estab" style="font-family: 'Humanst521BT'; white-space: pre; max-width: 100%; overflow-x: hidden; text-overflow: ellipsis;" v-html="decodeChars(item.titulo)"> </span>
                                        <span style="font-family: 'Humanst521LTBT'; font-size: 1.8vh;"> R$ {{ getCurrency(item.valor) }}</span>
                                    </div>

                                </div>
                                <div style="display: flex; width: 100%; justify-content: center; margin-top: 1vh;">
                                    <div style="display: flex; flex-direction: row; justify-content: space-around; align-items: center; width: 100%;">

                                        <router-link :to="{ params: { product: truncateAnuncio(item), stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterAnuncio'}">
                                            <div style="display: flex; flex-direction: row; margin-bottom: 0.8vh; cursor: pointer;">
                                                <img style="width: 3vh; height: 3vh; margin-right: 6px; object-fit: contain;" src='/static/imgs/ic_edit_sq.png' alt="Foto Principal" class="imgDestaques"/><br>
                                                <span style="align-self: center;">{{ getInterText(inter_ind.editar) }}</span>
                                            </div>
                                        </router-link>

                                        <div style="display: flex; flex-direction: row; align-items: center;" @click="sendAprovado(item)">
                                            <img v-if="item.ativo"  style="width: 2.2vh; height:2.2vh; margin-right: 6px;" src='/static/imgs/ic_ball_green.png' alt="Foto Principal" class="imgDestaques"/>
                                            <img v-if="!item.ativo" style="width: 2.2vh; height:2.2vh; margin-right: 6px;" src='/static/imgs/ic_ball_red.png' alt="Foto Principal" class="imgDestaques"/>
                                            <br><br><br>
                                            <span v-if="item.ativo"  style="align-self: center; font-size: 2vh;">{{ getInterText(inter_ind.ativa) }}</span>
                                            <span v-if="!item.ativo" style="align-self: center; font-size: 2vh;">{{ getInterText(inter_ind.desativada) }}</span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>



                    <!-- ################    Botao Enviar    ################# -->
                    <div style="display: flex; justify-content: center;" v-if="currentTab == 1">
                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterEstabFirst'}">
                            <div style="margin-top: 5vh; padding: 1.3vh; margin-bottom: 10vh; background-color: var(--bg-blue); text-align: center; border-radius: 8px; width: 30vw;" onMouseOver="this.style.cursor='pointer'">
                                <span style="color: white; font-size: 3.5vh;">{{ getInterText(inter_ind.criar_pagina) }}</span>
                            </div>
                        </router-link>
                    </div>

                    <div style="display: flex; justify-content: center;" v-if="currentTab == 5">
                        <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'RegisterAnuncio'}">
                            <div style="margin-top: 5vh; padding: 1.3vh; margin-bottom: 10vh; background-color: var(--bg-blue); text-align: center; border-radius: 8px; width: 30vw;" onMouseOver="this.style.cursor='pointer'">
                                <span style="color: white; font-size: 3.5vh;"> Criar Anúncio </span>
                            </div>
                        </router-link>
                    </div>







                </div>

            </div>


            <!--Barra de rodapé -->
            <div class="active">
                <div class="div_pat" v-if="cats.length!=0">
                    <span class="tx_parceiros">{{ getInterText(inter_ind.parceiros) }}</span><br>
                    <a v-for="item in barra_pat" :href="item.url" target=”_blank”><img :src="item.imgPath" class="im_pat"/></a>
                </div>
            </div>

        </div>


        <div class="div_login_m" v-if="showLogin" >
            <div class="parts_m">
                <div style="display: flex; justify-content: flex-end; width: 100%; margin-right: -45vw;" @click="setShowLogin(false)">
                    <img src="/static/imgs/bt_close_c.png" class="im_close_w" onMouseOver="this.style.cursor='pointer'">
                </div>

                <div style="text-align: center; margin-top: 5vh;">
                    <img src="/static/imgs/advicep_horizontal_w.png" alt="menu" style="height: 8vh">
                </div>


                <div class="div_face_w" style="margin-top: 10vh;" @click="externalLoginFace_checkLoginState()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_face_blue.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m"> {{ getInterText(inter_ind.entre_face) }} </span>
                    </div>
                </div>



                <div class="div_face_w" style="margin-top: 1vh; margin-bottom: 5vh" @click="externalLoginGoogle_startApp()">
                    <div class="div_faceim">
                        <img src="/static/imgs/ic_google.png" alt="facebook" class="im_face">
                    </div>

                    <div class="div_facetx">
                        <span class="tx_face_m unselectable"> {{ getInterText(inter_ind.entre_google) }} </span>
                    </div>
                </div>





                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(1, true)" v-if="!editing[1].status" onMouseOver="this.style.cursor='pointer'" tabindex="2">E-mail</span>
                    <div class="hr_w" @click="clickInput(1, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[1].status"/>
                    <span class="tx_nome_w" @click="clickInput(1, false)" v-if="editing[1].status">E-mail</span>
                    <input id="emailid" class="input_name_w" type="text" v-model="editing[1].texto" v-if="editing[1].status" tabindex="3"/>
                    <span v-if="!checkEmail(editing[1].texto) && editing[1].texto.length>5" class="error_msg">{{ getInterText(inter_ind.email_invalido) }}</span>
                </div>

                <div class="div_nome_l">
                    <span class="tx_nome_before_w" @click="clickInput(0, true)" v-if="!editing[0].status" onMouseOver="this.style.cursor='pointer'"> {{ getInterText(inter_ind.senha) }} </span>
                    <div class="hr_w" @click="clickInput(0, true)" onMouseOver="this.style.cursor='pointer'" v-if="!editing[0].status"/>
                    <span class="tx_nome_w" @click="clickInput(0, false)" v-if="editing[0].status"> {{ getInterText(inter_ind.senha) }} </span>
                    <input id="nameid" class="input_name_w" type="password" v-model="editing[0].texto" v-if="editing[0].status" tabindex="4"/>
                    <span v-if="!checkPass(editing[0].texto) && editing[0].texto!=''" class="error_msg">{{ getInterText(inter_ind.senha_errada) }}</span>
                </div>

                <div class="div_check" style="margin-top: 4vh;">
                    <div class="div_check_in" @click="changeCheckState(0)">
                        <span v-if="valid.enterAuto" class="tx_checkbox">&#10003;</span>
                    </div>
                    <span class="tx_check" style="flex-grow: 1">{{ getInterText(inter_ind.entrar_auto) }}</span>
                    <span class="tx_check" style="cursor: pointer;">{{ getInterText(inter_ind.esqueceu_senha) }}</span>
                </div>

                <span v-if="senhaErrada" class="error_msg"> {{ getInterText(inter_ind.senha_errada) }} </span>
                <div style="text-align: center;">
                    <span v-if="userNaoCadastrado" class="error_msg"> {{ getInterText(inter_ind.usuario_nao_cadastrado) }}</span>
                </div>


                <img v-if="loading.user" src="/static/imgs/loading5.gif" alt="Carregando" class="im_loading_up">

                <div style="display: flex; flex-direction: row; margin-top: 10vh">
                    <div class="div_botao_login" style="margin-right: 2vw; background-color: white;" @click="tryLogin()" onMouseOver="this.style.cursor='pointer'" tabindex="4">
                        <span class="tx_continuar_w unselectable" style="color: var(--bg-blue);"> {{ getInterText(inter_ind.entrar) }} </span>

                    </div>
                    <router-link :to="{ params: { stabs: estabs_full, categs: cats_full, idCat: idCat, anuncios: anuncios}, name: 'registerUser'}">
                        <div class="div_botao_login">
                            <span class="tx_continuar_w unselectable" style="font-weight: normal;"> {{ getInterText(inter_ind.cadastre) }} </span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <filter id="colorize" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.18
                 0 0 0 0 0.24
                 0 0 0 0 0.31
                 0 0 0 1 0"/>
        </filter>

        <filter id="colorize_blue" color-interpolation-filters="sRGB">
            <feColorMatrix type="matrix" values=
                "0 0 0 0 0.0625
                 0 0 0 0 0.375
                 0 0 0 0 0.672
                 0 0 0 1 0"/>
        </filter>

        <div class="overlay" @click="changeSideBar()"></div>

    </div>
</template>

<script>
    import axios from 'axios'
    import { advMixin } from '../scripts/advMixin'

    export default {
        mixins: [advMixin],
        name: 'MinhaPagina',
        data () {
            return {
                name: 'MinhaPagina',
                estabs: [],
                cats: [],
                estabs_full: [],
                estabs_search: [],
                cats_full: [],
                idCat: 0,
                search_text: "",
                showingSearch: false ,
                response: {
                    status: "ok"
                },
                statusEstab: 0,
                tituloCat: "Destaques",
                corCat: "#96989b",
                panoInd: 0,
                pano: [
                    {
                        imgPath: "static/imgs/pano_d_01.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_02.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_03jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_04.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_05.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_06.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_07.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_08.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                    {
                        imgPath: "static/imgs/pano_d_09.jpg",
                        shift: 0,
                        shift_m: 0
                    },
                ]
            }
        },
        methods: {
            getPanoImg() {
                return this.pano[this.panoInd].imgPath;
            },
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            },
            closeKey() {
                console.log('closeKeyboard');
                this.$refs.search_i.blur();
            },
            adjustCaracterEncoding() {
                var i;
                var vm = this;
                for (i=0 ; i<vm.estabs_full.length ; i++) {
                    try {
                        vm.estabs_full[i].nome = decodeURIComponent(escape(vm.estabs_full[i].nome));
                    } catch (e) {
                        vm.estabs_full[i].nome = unescape(vm.estabs_full[i].nome);
                    }
                    try {
                        vm.estabs_full[i].horario = decodeURIComponent(escape(vm.estabs_full[i].horario));
                    } catch (e) {
                        vm.estabs_full[i].horario = unescape(vm.estabs_full[i].horario);
                    }
                    try {
                        vm.estabs_full[i].responsavel = decodeURIComponent(escape(vm.estabs_full[i].responsavel));
                    } catch (e) {
                        vm.estabs_full[i].responsavel = unescape(vm.estabs_full[i].responsavel);
                    }
                    try {
                        vm.estabs_full[i].rua_num = decodeURIComponent(escape(vm.estabs_full[i].rua_num));
                    } catch (e) {
                        vm.estabs_full[i].rua_num = unescape(vm.estabs_full[i].rua_num);
                    }
                    try {
                        vm.estabs_full[i].bairro = decodeURIComponent(escape(vm.estabs_full[i].bairro));
                    } catch (e) {
                        vm.estabs_full[i].bairro = unescape(vm.estabs_full[i].bairro);
                    }
                    try {
                        vm.estabs_full[i].cidade = decodeURIComponent(escape(vm.estabs_full[i].cidade));
                    } catch (e) {
                        vm.estabs_full[i].cidade = unescape(vm.estabs_full[i].cidade);
                    }
                }
            },
            getEstabsCats() {
                console.log('Entrei no getEstabsCats()');

                var url1 = this.baseUrlApi + 'estabelecimentos';
                var url2 = this.baseUrlApi + 'categorias';

                var vm = this;
                vm.loading.cats = true;
                vm.loading.estabs = true;

                axios.all([
                    axios.get(url1),
                    axios.get(url2),
                ])
                    .then(axios.spread(function(r1, r2) {
                        vm.estabs_full = r1.data;
                        vm.cats_full = r2.data;

                        //vm.dataj = Object.assign({}, vm.dataj, { estabs_full: r1.data, cats_full: r2.data });
                        //vm.$set(vm, 'dataj', { estabs_full: r1.data, cats_full: r2.data });

                        vm.adjustCaracterEncoding();

                        console.log('Estabelecimentos:');
                        console.log(vm.estabs_full);
                        console.log('Categorias:');
                        console.log(vm.cats_full);
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                        vm.atualizaParametros();
                    }))
                    .catch(function(error) {
                        vm.loading.cats = false;
                        vm.loading.estabs = false;
                        console.log('Error Catch' + error);
                    });
            },
            getEstabsSearch() {
                console.log('getEstabsSearch ' + this.search_text);

                this.estabs_search = [];

                this.cats = [
                    {
                        nome: this.inter_pt[this.inter_ind.resultado_busca],
                        nomeEn: this.inter_en[this.inter_ind.resultado_busca],
                        nomeEs: this.inter_es[this.inter_ind.resultado_busca],
                        id: -1
                    }
                ];




                if (this.search_text.length<3) {
                    console.log('getEstabsSearch::nao vou buscar');

                    if (this.search_text.length==0) {
                        this.cats = this.cats_full;
                    }
                    return ;
                }

                var search_text2 = this.search_text.toLowerCase();
                var i;
                for (i=0 ; i<this.estabs_full.length ; i++) {
                    var estab = this.estabs_full[i];

                    if (estab.nome.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.bairro.toLowerCase().indexOf(search_text2)>=0 ||
                        estab.descricao2.toLowerCase().indexOf(search_text2)>=0) {
                        this.estabs_search.push(estab);
                        console.log('search: ' + estab.nome);
                    }
                    else {
                        var j;
                        for (j=0 ; j < estab.tbCategoriaEstabelecimentos.length ; j++) {
                            var catt = estab.tbCategoriaEstabelecimentos[j];
                            if (catt.nome.toLowerCase().indexOf(search_text2)>=0) {
                                this.estabs_search.push(estab);
                                console.log('search: ' + estab.nome);
                                break;
                            }
                        }
                    }
                }
            },
            getEstabs(idCat) {
                console.log('getEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
                                estabs.push(estab);
                            }
                        }
                    }
                }

                this.estabs = estabs;

                return estabs;
            },
            hasEstabs(idCat) {
                console.log('hasEstabs ' + idCat);
                var vm = this;

                var estabs = [];

                if (idCat==-1) {
                    estabs = this.estabs_search;
                }
                else {
                    var i;
                    for (i = 0; i < vm.estabs_full.length; i++) {
                        var estab = vm.estabs_full[i];

                        var j;
                        for (j = 0; j < estab.tbCategoriaEstabelecimentos.length; j++) {
                            var cat = estab.tbCategoriaEstabelecimentos[j];
                            if (cat.id == idCat && (this.cityIndex == 0 || estab.cidade == this.city_full[this.cityIndex].nome) && estab.ativo && estab.aprovado) {
                                return true;
                            }
                        }
                    }
                }

                return false;
            },
            atualizaEstabs(idCatAtual) {
                console.log('atualizaEstabs id: ' + idCatAtual);
                var vm = this;

                if (idCatAtual==0) {
                    vm.cats = vm.cats_full;
                    console.log('cats:');
                    console.log(vm.cats);
                }
                else {
                    // vm.estabs = [];
                    vm.cats = [];

                    // Ta nesse for separado para que mesmo se nao tiver nenhum estabelecimento na categoria selecionada ele altere o tituloCat.
                    var i;
                    for (i = 0; i < vm.cats_full.length; i++) {
                        var cat = vm.cats_full[i];
                        if (cat.id == idCatAtual) {
                            vm.tituloCat = cat.nome;
                            vm.corCat = cat.cor;
                            vm.idCat = cat.id;
                            vm.cats.push(cat);
                            break;
                        }
                    }
                }


                $('#sidebar').removeClass('active');
                $('.overlay').fadeOut();
                $('#icmenu').removeClass('open');
                // $('#div_pat_s').fadeOut(0);
            },
            atualizaParametros() {
                console.log('atualizaParametros');
                console.log(this.$route.query);

                if (this.$route.query.idCat == null) {
                    // this.tituloCat = "Destaques";
                    this.idCat = 0;
                    // this.corCat = "#96989b";
                    console.log('id eh nulo');
                } else {
                    this.idCat = this.$route.query.idCat;
                    console.log('id eh valido ' + this.idCat);
                }

                this.getCities();

                this.atualizaEstabs(this.idCat);
            },

            trimAll(str){
                return str.replace(/\s/g,'');
            }
        },
        created() {
            console.log('created minha pagina!!');

            if (this.user.currentTab == undefined || this.user.currentTab == 0) {
                this.user.currentTab = 3;
            }
            this.currentTab = this.user.currentTab;

            if (this.$route.params.login) {
                this.setShowLogin(true);
            }

            if (this.$route.params.indexCity != null) {
                this.cityIndex = this.$route.params.indexCity;
                console.log('setando o cityIndex para: ', this.cityIndex);
            }

            this.getCommentaries(this.user.id, 0);

            if (this.$route.params.stabs) {
                console.log('Usando estabs e cats passados por parametro!!');
                this.estabs_full = this.$route.params.stabs;
                this.cats_full = this.$route.params.categs;
                this.atualizaParametros();
            }
            else {
                console.log('Baixando estabs!!');
                this.getEstabsCats();
            }

            if (this.$route.params.anuncios) {
                console.log('Usando anuncios passados por parametro!!');
                this.anuncios = this.$route.params.anuncios;
            }
            else {
                console.log('Baixando estabs!!');
                this.getAnuncios();
            }

            console.log('Terminei o created!!');
        },
        beforeMount() {
            console.log('beforeMount!!');

            console.log('Terminei o beforeMount!!');
        },
        mounted() {
            console.log('mounted!!');


            this.barra_pat = this.shuffle(this.barra_pat);

            // this.panoInd = (this.panoInd + 1) % 5;
            this.panoInd = Math.floor(Math.random() * 5);
            // this.panoInd = 0;

            if (this.user.idioma > 0) {
                this.changeIdioma(this.user.idioma);
            }

            console.log('Terminei o mounted!!');
        },

    }



</script>


<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/advDesk.css" scoped/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        /*background-color: #f0f0f0;*/
        background-color: var(--main-bg-color);
        overflow-y: scroll;
    }
    .roothome::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .im_social {
        display: inline-block;
        /*width: 35px;*/
        /*width: 2.6vw;*/
        height: 90%;
        width: 100%;
        margin-top: 0.2vh;
        /*padding: 3px;*/
        object-fit: scale-down;
        /*padding: 0.1vw;*/
        vertical-align: middle;
    }
    .bar_idiomas {
        display: flex;
        vertical-align: middle;
        /*background-color: red;*/
        /*padding-left: 1vw;*/
        align-items: center;
        justify-content: space-evenly;
        background-image: url('/static/imgs/ic_barra_idiomas_w.png');
        /*background-size: auto 100%;*/
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 3.5vh;
    }

    .title4 {
        /*height: 275px;*/
        /*max-height: 275px;*/
        text-align: center;

        margin-top: var(--top-bar-heigth_desk);

        /*background-color: red;*/
    }

    .im_pat {
        height: 1.34cm;
        margin-left: 0.75cm;
        margin-right: 0.75cm;
        margin-bottom: 0.75cm;
        margin-top: 0.5cm;
        object-fit: contain;
    }
    .div_pat {
        position: page;
        bottom: 0;
        /*background-color: #949494;*/
        /*background-color: #C4C4C4;*/
        background-color: #CDCDCD;
        padding-top: 0.25cm;
        /*background-color: #E4E4E4;*/
        text-align: center;
    }
    .tx_parceiros {;
        font-size: 12pt;
        /*color: #040505;*/
        color: #858585;
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2vh;
        width: 100%;
        display: flex;
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
    }

    .div_face_w {
        display: flex;
        flex-direction: row;
        align-items: center;

        display: flex;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;

        width: 90%;
        padding: 1.5vw;
        background: white;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        cursor: pointer;
    }

    .div_faceim {
        /*background: pink;*/
        display: flex;
        justify-content: center;
        flex-basis: 0;
        flex-grow: 1;
    }

    .im_face {
        /*background: red;*/
        display: flex;
        width: 3vh;
        height: 3vh;
        -webkit-filter: brightness(150%);
        filter: brightness(150%);
    }

    .div_facetx {
        /*background: brown;*/
        display: flex;
        justify-content: center;
        flex-grow: 1;
    }



    div_botao_t {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 5vh;
    }

    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
    }

    .tx_continuar {
        display: flex;
        flex-direction: row;
        font-weight: normal;
        color: unset;
        font-size: 2.5vh;
        /*font-family: 'Humanst521LTBT', Helvetica, Arial,sans-serif;*/
    }

    .im_loading_up {
        width: 50px;
        height: 50px;
    }

    .div_botao_t_w {
        display: flex;
        align-items: center;
        padding: 2vh;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_t_w {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1vh;
        color: white;
        width: 80%;
    }

    .div_botao_t_w {
        border-style: none;
        background: white;
        padding: 1.3vh;
        height: 5vh;
        color: var(--bg-blue);
    }

    .div_botao_t {
        display: flex;
        align-items: center;
        width: 80%;
        display: flex;
        color: white;
        background: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 1vh;
    }

    .div_botao_t {
        background: unset;
        border-color: rgba(255, 255, 255, .7);
        padding: 1.3vh;
        height: 5vh;
        color: white;
        cursor: pointer;
        width: 80%;
    }

    .div_botao_t:active {
        border-color: var(--bg-blue);
        background: white;
        color: var(--bg-blue);
    }

    .div_botao_t.tx_continuar:active {
        color: var(--bg-blue);
    }

    .custom-select-filtro {
        width: 60%;
        height: 4.5vh;
        background-color: var(--bg-blue-grad1);
        border-color: transparent;
        border-width: 1px;
        border-style: solid;
        text-align: center;

        margin-right: 2.5%;
        margin-left: 2.5%;
        margin-top: 1.5vh;
        margin-bottom: -1.5vh;

        display: flex;
    }

    select#sel_cats {
        margin-left: 2vw;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;       /* Remove default arrow */
        outline: none;
        background-color: var(--bg-blue-grad1);
        /*background-color: red;*/
        display: flex;
        align-items: center;
        justify-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: none;
        padding-left: 2%;
        /*font-size: 12pt;*/
        font-size: 2vh;
    }

    .hr_pat {
        width: 85%;
        margin-top: 0;
        margin-bottom: 5%;
        color: white;
        background-color: white;
        border-color: white;
    }


    .im_pat_m {
        /*background-color: #0f62ac;*/
        width: 85%;
        /*margin-right: 2%;*/
        /*margin-bottom: 2%;*/

    }

    .div_pat_m {
        position: page;
        bottom: 0;
        width: 100%;
        display: inline-block;
        /*background-color: #CDCDCD;*/
        padding-top: 0;
        /*padding-bottom: 0.5cm;*/
        text-align: center;
        /*font-size: 0;*/
    }


    .div_pat_m {
        background-color: transparent;
        /*background-color: pink;*/
        /*background-color: #0171bb;*/
        /*position: fixed;*/
        /*bottom: 0;*/
        width: 100%;
        height: 6%;
        /*display: inline-block;*/
        /*margin-bottom: 5vh;*/
    }

    #dismiss {
        top: 0;
        left: 0;
        margin-left: 5px;
        margin-top: 10px;
    }


    /****************** Login window *****************/
    .div_login_m {
        /*background: rgba(1, 0, 0, .7);*/
        /*background: blue;*/
        flex-direction: column;
        display: flex;
        justify-content: center;
        position: fixed;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow-x: auto;
        overflow-y: auto;
        z-index: 1000;
    }

    .parts_m {
        background-color: blue;
        background-image: url('/static/imgs/bg_login.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        /*background: red;*/
        /*box-shadow: 5px 5px 5px black;*/
        width: 100vw;
        height: 100vh;
        /*height: max-content;*/
        display: flex;
        padding: 8vw;
        padding-top: 1vw;
        align-items: center;
        overflow-y: auto;
        flex-direction: column;
        padding-right: 30vw;
        padding-left: 30vw;
    }

    .im_close_w {
        display: flex;
        justify-self: flex-end;
        width: 30px;
        height: 30px;
        margin-right: -6vw;
        margin-top: 0;
        cursor: pointer;
    }

    .im_close_w {
        filter: brightness(0%) invert(100%);
        -webkit-filter: brightness(0%) invert(100%);
    }

    .tx_nome_before_w, .tx_nome_w {
        display: flex;
        width: 100%;
        font-size: 25pt;
        /*color: gray;*/
    }

    .tx_nome_w {
        color: white;
        font-size: 3vh;
    }

    .tx_nome_before_w {
        color: white;
        font-family: 'Humanst521BT';
        font-size: 3vh;
    }

    .hr_w {
        width: 100%;
        height: 2px;
        margin-top: 5px;
        background: gray;
    }

    .hr_w {
        background-color: white;
    }

    .error_msg {
        font-family: 'Humanst521BT';
        color: red;
        font-size: 2.5vh;
    }

    .div_check {
        display: flex;
        width: 100%;
        margin-top: 0;
        align-items: center;
    }

    .div_check_in {
        display: flex;
        border-width: 2px;
        border-style: solid;
        border-color: white;
        width: 15px !important;
        height: 15px !important;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        cursor: pointer;
    }

    .tx_checkbox {
        color: white;
        font-weight: bold;
        margin-top: -4px;
    }

    .tx_check {
        color: white;
        font-style: normal;
        text-align: center;
        display: flex;

        font-weight: normal;
        display: flex;
        font-size: 9pt;
        font-size: 2.5vh;
        margin-left: 1.5vw;

        justify-items: flex-end;
        align-content: flex-end;
        alignment-baseline: bottom;
    }

    .div_botao_login {
        border-style: solid;
        border-color: white;
        border-width: 1px;
        width: 15vw;
        height: 5vh;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        /*background: white;*/

        color: white;
    }

    .tx_status_estab, .tx_status_estab_s {
        font-size: 3.5vh;
        border-style: solid;
        /*border-color: var(--main-bg-color);*/
        cursor: pointer;
        border-color: transparent;
        border-width: 5px;
        border-top: none;
        border-right: none;
        border-left: none;
    }
    .tx_status_estab_s {
        border-color: var(--bg-blue-circle);
    }

    .noScrollMenu {
        scrollbar-width: none;
        -ms-overflow-style: none;
    }
    .noScrollMenu::-webkit-scrollbar {
        width: 0px; /* For Chrome, Safari, and Opera */
        display: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/MinhaPagina.vue